
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/Login/LoginEmpresas.css"
import { useUserAdmin } from "../admin/UserContext";
/* Material UI */
import { CircularProgress } from '@mui/material';

/* Iconos React */
import { FiAlertCircle } from 'react-icons/fi';
import { TbLock } from "react-icons/tb";
import { TbLockOpen } from "react-icons/tb";

/* imagenes */
import Logo from "../Image/Logo.png"
import BackgroundImage from "../Image/Fondo_03.png";

export const Login = () => {
    const [showPassword, setShowPassword] = React.useState(false);
    const [emailError, setEmailError] = useState('');
    const navigate = useNavigate();
    const [passwordError, setPasswordError] = useState('');
    const [loading, setLoading] = useState(false);
    const { setInformacionEmpresa, setInformationUsuario } = useUserAdmin();
    const backendURL = process.env.REACT_APP_BACKEND_URL;

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        const formData = new FormData(event.currentTarget);
        const email = formData.get('email');
        const password = formData.get('password');

        if (!validateEmail(email)) {
            setEmailError('El correo electrónico no es válido');
            setLoading(false);
            return;
        } else {
            setEmailError('');
        }

        try {
            const response = await fetch(`${backendURL}/api/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            if (!response.ok) {
                setPasswordError('El correo o contraseña están incorrectos');
                setLoading(false);
                return;
            }

            const data = await response.json();
            const { token, user } = data; // Desestructurar para obtener el token y el usuario
            // 🔐 Guardar token y usuario en context o storage
            setInformacionEmpresa(token);
            setInformationUsuario(user);

            // Si quieres redirigir
            navigate('/inicio/administrador');


        } catch (error) {
            console.error('Error al procesar la solicitud:', error);
        } finally {
            setLoading(false);
        }
    };

    const validateEmail = (email) => {
        // Expresión regular para validar correo electrónico
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };


    return (

        <section style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundImage: `url(${BackgroundImage})`, height: '100vh' }}>

            <form className="formempresaingreso" onSubmit={handleSubmit}>


                <section className="logoselecionempresa" style={{
                    width: '200px'
                }}>
                    <img src={Logo} className='logosmartmemorialiniciosecionempresa' alt="smart memorial" title="smart memorial" />
                </section>
                <section className="TituloPaginaLoginEmpresa">
                    <h1 className="Bienvenido">Bienvenido a</h1>
                    <h1 className="TituloDosEmpresa"> administrador de Hod</h1>
                </section>


                <div className="flex-column">
                    <label>Email </label>
                </div>
                <div className="inputFormEmpresapaginaingreso">
                    <svg
                        style={{ fill: '#ffff' }}
                        height="20"
                        viewBox="0 0 32 32"
                        width="20"

                    >
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                d="m30.853 13.87a15 15 0 0 0 -29.729 4.082 15.1 15.1 0 0 0 12.876 12.918 15.6 15.6 0 0 0 2.016.13 14.85 14.85 0 0 0 7.715-2.145 1 1 0 1 0 -1.031-1.711 13.007 13.007 0 1 1 5.458-6.529 2.149 2.149 0 0 1 -4.158-.759v-10.856a1 1 0 0 0 -2 0v1.726a8 8 0 1 0 .2 10.325 4.135 4.135 0 0 0 7.83.274 15.2 15.2 0 0 0 .823-7.455zm-14.853 8.13a6 6 0 1 1 6-6 6.006 6.006 0 0 1 -6 6z"
                            ></path>
                        </g>
                    </svg>
                    <input
                        required
                        id="email"
                        name="email"
                        autoComplete="email"
                        className="inputloginempresa"
                        placeholder="ingrese email"
                        style={emailError ? { borderColor: 'red' } : {}} />
                </div>

                <div className="flex-column">
                    <label>Password </label>
                </div>
                <div className="inputFormEmpresapaginaingreso" >
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                            background: "transparent",
                            border: "0px",
                            padding: "0px",
                        }}
                    >
                        {showPassword ? (
                            <TbLockOpen style={{ fontSize: "1.5rem", color: "#ffff" }} />
                        ) : (
                            <TbLock style={{ fontSize: "1.5rem", color: "#ffff" }} />
                        )}
                    </button>
                    <input
                        required
                        name="password"
                        id="password"
                        autoComplete="current-password"
                        type={showPassword ? "text" : "password"}
                        className="inputloginempresa"
                        placeholder="Ingrese contraseña" />
                </div>
                <div className="contiene-error-mensaje" style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', left: '0' }}>
                    {passwordError &&
                        <span className="errormessagelogin" style={{ color: '#ffff', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                            <FiAlertCircle className='icon-error' style={{ marginRight: '5px' }} />{passwordError}
                        </span>}
                </div>
                <div className="contiene-error-mensaje" style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', left: '0' }}>
                    {emailError && (
                        <span className="errormessagelogin" style={{ color: '#ffff' }}>
                            <FiAlertCircle className='icon-error' />
                            {emailError}
                        </span>
                    )}
                </div>
                <div className="cotienenbutonloginempresa">
                    <button type='submit' className="buttoningresoempresasubmit"> {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'Iniciar Sesión'}</button>
                </div>


            </form>



        </section>

    )
}
